import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MenuPrice } from '../../api/v1/models/menu-price';
import { ConfigRepository } from '../repositories/config.repository';

@Pipe({
    name: 'outletPrice',
    standalone: true
})
export class OutletPricePipe implements PipeTransform {
  constructor(private configRepository: ConfigRepository) { }

  transform(MenuPrices: MenuPrice[]): Observable<number | null | undefined> {
    return this.configRepository.activeOutletId$.pipe(
      map((id) => id ? MenuPrices.find(p => p.storeId == id)?.price : null)
    )
  }
}
